import { useMemo } from "react";
import Sldier from "../slider";

export default function TextWithGallary({ text }) {
  const textBlocks = useMemo(() => {
    const blocks = text?.split("#gallary#").map((text, index) => {
      if (index % 2 === 0) {
        return (
          <div
            className="text"
            key={index}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        );
      }
      const arrMatches = text
        .match(/<img.*?src=["'](.*?)["'].*?>/gim)
        .map((item) => item.match(/<img.*?src=["'](.*?)["'].*?>/)[1]);
      return (
        <Sldier
          key={index}
          images={arrMatches.map((img) => {
            return {
              full: img,
              thumb: img,
            };
          })}
        />
      );
    });
    return blocks;
  }, [text]);

  return <div>{textBlocks.map((block) => block)}</div>;
}
